import Cleaning, { getServerSideProps } from './Cleaning';
export default Cleaning;
export { getServerSideProps };
